import { isValidDateTimeString } from './type_guards';

/**
 * Gets the start date of the current quarter as an ISO string
 * @returns {string} ISO string representation of the current quarter's start date
 */
export function getQuarterStart() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  
  // Determine quarter start month based on current month
  let quarterStartMonth;
  if (month >= 9) {        // Oct, Nov, Dec -> Q4
    quarterStartMonth = 9;
  } else if (month >= 6) { // Jul, Aug, Sep -> Q3
    quarterStartMonth = 6;
  } else if (month >= 3) { // Apr, May, Jun -> Q2
    quarterStartMonth = 3;
  } else {                 // Jan, Feb, Mar -> Q1
    quarterStartMonth = 0;
  }
  
  const quarterStart = new Date(year, quarterStartMonth, 1);
  quarterStart.setHours(0, 0, 0, 0);
  return quarterStart.toISOString();
}

/**
 * Gets the start date of the current month as an ISO string
 * @returns {string} ISO string representation of the current month's start date
 */
export function getMonthStart() {
  const now = new Date();
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  monthStart.setHours(0, 0, 0, 0);
  return monthStart.toISOString();
}

/**
}

 * Determines whether the DataPass banner should be shown to the user
 * @param {string|null} lastAcknowledgeDate - The user's last acknowledgement timestamp
 * @param {boolean} dismissedUntilLogin - Whether the banner was dismissed until next login
 * @param {function} getStart - Function to get the start date of the current period
 * @returns {boolean} true if the banner should be shown, false otherwise
 */
export function shouldShowDataPassBanner(
  lastAcknowledgeDate,
  dismissedUntilLogin,
  getStart = getQuarterStart,
) {
  if (dismissedUntilLogin) {
    return false;
  }

  if (!isValidDateTimeString(lastAcknowledgeDate)) {
    return true;
  }

  const start = getStart();
  return lastAcknowledgeDate < start;
}
